import React from 'react';
import {Link} from 'react-router-dom';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import {useMediaQuery} from '@mui/material';
import {Container} from '@mui/material';
import Grid from '@mui/material/Grid';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import PageNav from '../../components/PageNav';
// ICON LIST
import {
  macWP,
  DigMapAdmin,
  DigMapIcon1,
  DigMapIcon2,
  DigMapIcon3,
  DigMapIcon4,
  UserAccessAdmin,
  UserAccessIcon1,
  UserAccessIcon2,
  UserAccessIcon3,
  MobileAppAdmin,
  MobileAppIcon1,
  MobileAppIcon2,
  MobileAppIcon3,
  OthersAdmin,
  OthersIcon1,
  OthersIcon2,
  OthersIcon3,
  OthersIcon4,
} from '../../assets';
import {Language} from '../../context/LanguageContext';
import './index.scss';

const AdminPage = (props) => {
  const {language, newObj} = Language();
  const role = props.role;
  const theme = createTheme({
    typography: {
      fontFamily: ['Montserrat'],
    },
  });

  const digitalMapAdminRole = role?.includes('digital_mapping_admin');
  // const lintramaxAdminRole = role?.includes('lintramax_admin');
  // const iotAdminRole = role?.includes('iot_admin');
  const userManagementRole = role?.includes('user_management_admin');
  const applicationManagementRole = role?.includes(
    'application_management_admin'
  );
  const atdAdminRole = role?.includes('atd_admin');
  const pengesyoranBajaAdminRole = role?.includes('pengesyoran_baja_admin');
  const kewanganAdminRole = role?.includes('kewangan_admin');
  const pesertaLotAdminRole = role?.includes('peserta_lot_admin');
  const ppplsDataAdminRole = role?.includes('pppls_data_admin');
  const documentationAdminRole = role?.includes('documentation_admin');
  const isXsScreen = useMediaQuery(theme.breakpoints.between('xs', 'sm'));
  const isSmScreen = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container
        maxWidth='100%'
        sx={{
          backgroundImage: `url(${macWP})`,
          backgroundRepeat: 'no-repeat',
          backgroundColor: (t) =>
            t.palette.mode === 'light'
              ? t.palette.grey[50]
              : t.palette.grey[900],
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          padding: isXsScreen
            ? '0px 1px 1px 1px !important'
            : isSmScreen
            ? '0px 1px 1px 1px !important'
            : '10px !important',
          marginTop: '60px',
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          // height:  "100%",
        }}
        className='adminOuterContainer'
      >
        <PageNav title={newObj.AdministratorWord[language]} href='/' />
        <Container
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <Grid
            container
            component='main'
            rowSpacing={1}
            columnSpacing={{xs: 1, sm: 2, md: 3}}
            className='containerAdmin'
          >
            {digitalMapAdminRole && (
              <Grid xs={12} sm={12} className='gridAdminItem' item>
                <Box className='boxAdmin'>
                  <Box className='boxAdminHead'>
                    {newObj.DigitalMappingWord[language]}
                  </Box>
                  <Box className='boxAdminWrapper'>
                    <Box className='boxAdminImgCtr'>
                      <img
                        src={DigMapAdmin}
                        className='boxAdminImg'
                        alt='digmapadmin'
                      />
                    </Box>
                    <Box className='boxAdminMenu'>
                      <Box className='boxAdminMenuItem'>
                        <Link to='/mapFiles'>
                          <img
                            className='itemImg'
                            src={DigMapIcon1}
                            alt='DigMapIcon1'
                          />
                          <Box className='itemText'>
                            <p>
                              <strong>
                                {newObj.MapFileRasterDirianPokokWord[language]}
                              </strong>
                            </p>
                            <p>
                              {
                                newObj.MapFileRasterDirianPokokDescription[
                                  language
                                ]
                              }
                            </p>
                          </Box>
                        </Link>
                      </Box>
                      <Box className='boxAdminMenuItem'>
                        <Link to='/uploadmap'>
                          <img
                            className='itemImg'
                            src={DigMapIcon2}
                            alt='DigMap2'
                          />
                          <Box className='itemText'>
                            <p>
                              <strong>{newObj.UploadMapWord[language]}</strong>
                            </p>
                            <p>{newObj.UploadMapDescription[language]}</p>
                          </Box>
                        </Link>
                        <Link to='/uploadmap' className='itemBtn'>
                          Upload Map
                        </Link>
                      </Box>
                      <Box className='boxAdminMenuItem'>
                        <Link to='/documentreport'>
                          <img
                            className='itemImg'
                            src={DigMapIcon3}
                            alt='DigMap3'
                          />
                          <Box className='itemText'>
                            <p>
                              <strong>
                                {newObj.DocumentReportWord[language]}
                              </strong>
                            </p>
                            <p>{newObj.DocumentReportDescription[language]}</p>
                          </Box>
                        </Link>
                      </Box>
                      <Box className='boxAdminMenuItem'>
                        <Link to='/uploadreport'>
                          <img
                            className='itemImg'
                            src={DigMapIcon4}
                            alt='DigMap4'
                          />
                          <Box className='itemText'>
                            <p>
                              <strong>
                                {newObj.UploadDocumentReportWord[language]}
                              </strong>
                            </p>
                            <p>
                              {newObj.UploadDocumentReportDescription[language]}
                            </p>
                          </Box>
                        </Link>
                        <Link to={'/uploadreport'} className='itemBtn'>
                          Upload File
                        </Link>
                      </Box>
                    </Box>
                    {/* <List sx={{width: '100%', maxWidth: 300}}>
                      <Link
                        to='/mapfiles'
                        sx={{
                          textDecoration: 'none',
                        }}
                      >
                        <ListItem divider>
                          <ListItemAvatar>
                            <Avatar
                              src={mapFiles}
                              sx={{
                                background: 'transparent',
                                borderRadius: 0,
                                color: 'white',
                                objectFit: 'contain',
                                width: 'fit-content',
                                filter: 'invert(1)',
                              }}
                            />
                          </ListItemAvatar>
                          <ListItemText
                            sx={{color: 'white'}}
                            primary={newObj.MapFilesWord[language]}
                          />
                        </ListItem>
                      </Link>
                      <Link
                        to='/uploadmap'
                        sx={{
                          textDecoration: 'none',
                        }}
                      >
                        <ListItem divider>
                          <ListItemAvatar>
                            <Avatar
                              src={uploadMap}
                              style={{
                                background: 'transparent',
                                borderRadius: 0,
                                color: 'white',
                                objectFit: 'contain',
                                width: 'fit-content',
                                filter: 'invert(1)',
                              }}
                            />
                          </ListItemAvatar>
                          <ListItemText
                            sx={{color: 'white'}}
                            primary={newObj.UploadMapWord[language]}
                          />
                        </ListItem>
                      </Link>
                      <Link
                        to='/uploadreport'
                        sx={{
                          textDecoration: 'none',
                        }}
                      >
                        <ListItem divider>
                          <ListItemAvatar>
                            <Avatar
                              src={uploadDoc}
                              style={{
                                background: 'transparent',
                                borderRadius: 0,
                                color: 'white',
                                objectFit: 'contain',
                                width: 'fit-content',
                                filter: 'invert(1)',
                              }}
                            />
                          </ListItemAvatar>
                          <ListItemText
                            sx={{color: 'white'}}
                            primary={newObj.UploadDocumentReportWord[language]}
                          />
                        </ListItem>
                      </Link>
                      <Link
                        to='/documentreport'
                        sx={{
                          textDecoration: 'none',
                        }}
                      >
                        <ListItem divider>
                          <ListItemAvatar>
                            <Avatar
                              src={uploadMap}
                              style={{
                                background: 'transparent',
                                borderRadius: 0,
                                color: 'white',
                                objectFit: 'contain',
                                width: 'fit-content',
                                filter: 'invert(1)',
                              }}
                            />
                          </ListItemAvatar>
                          <ListItemText
                            sx={{color: 'white'}}
                            primary={newObj.DocumentReportWord[language]}
                          />
                        </ListItem>
                      </Link>
                    </List> */}
                  </Box>
                </Box>
              </Grid>
            )}

            {/* {iotAdminRole && (
              <Grid
                xs={12}
                sm={6}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Box className='boxAdmin'>
                  <Box
                    variant='body1'
                    sx={{
                      color: 'white',
                      backgroundColor: '#505559',
                      borderTopLeftRadius: '10px',
                      borderTopRightRadius: '10px',
                    }}
                    fontWeight='bold'
                    py={2}
                    pl={3}
                  >
                    {newObj.IoTWord[language]}
                  </Box>
                  <List sx={{width: '100%', maxWidth: 300}}>
                    <Link
                      to='/manageiotdevices'
                      sx={{
                        textDecoration: 'none',
                      }}
                    >
                      <ListItem divider>
                        <ListItemAvatar>
                          <Avatar
                            src={manageDevices}
                            style={{
                              background: 'transparent',
                              borderRadius: 0,
                              color: 'white',
                              objectFit: 'contain',
                              width: 'fit-content',
                              filter: 'invert(1)',
                            }}
                          />
                        </ListItemAvatar>
                        <ListItemText
                          sx={{color: 'white'}}
                          primary={newObj.ManageDevicesWord[language]}
                        />
                      </ListItem>
                    </Link>
                    <Link
                      to='/uploadiot'
                      sx={{
                        textDecoration: 'none',
                      }}
                    >
                      <ListItem divider>
                        <ListItemAvatar>
                          <Avatar
                            src={uploadIot}
                            style={{
                              background: 'transparent',
                              borderRadius: 0,
                              color: 'white',
                              objectFit: 'contain',
                              width: 'fit-content',
                              filter: 'invert(1)',
                            }}
                          />
                        </ListItemAvatar>
                        <ListItemText
                          sx={{color: 'white'}}
                          primary={newObj.UploadIoTDataWord[language]}
                        />
                      </ListItem>
                    </Link>
                    <Link
                      to='/uploadiotevent'
                      sx={{
                        textDecoration: 'none',
                      }}
                    >
                      <ListItem divider>
                        <ListItemAvatar>
                          <Avatar
                            src={uploadIot}
                            style={{
                              background: 'transparent',
                              borderRadius: 0,
                              color: 'white',
                              objectFit: 'contain',
                              width: 'fit-content',
                              filter: 'invert(1)',
                            }}
                          />
                        </ListItemAvatar>
                        <ListItemText
                          sx={{color: 'white'}}
                          primary={newObj.UploadIoTEventDataWord[language]}
                        />
                      </ListItem>
                    </Link>
                    <Link
                      to='/iotarchivefiles'
                      sx={{
                        textDecoration: 'none',
                      }}
                    >
                      <ListItem divider>
                        <ListItemAvatar>
                          <Avatar
                            src={iotArchived}
                            style={{
                              background: 'transparent',
                              borderRadius: 0,
                              color: 'white',
                              objectFit: 'contain',
                              width: 'fit-content',
                              filter: 'invert(1)',
                            }}
                          />
                        </ListItemAvatar>
                        <ListItemText
                          sx={{color: 'white'}}
                          primary={newObj.IoTArchiveFilesWord[language]}
                        />
                      </ListItem>
                    </Link>
                    <Link
                      to='/iconsettings'
                      sx={{
                        textDecoration: 'none',
                      }}
                    >
                      <ListItem divider>
                        <ListItemAvatar>
                          <Avatar
                            src={lintraMax}
                            style={{
                              background: 'transparent',
                              borderRadius: 0,
                              color: 'white',
                              objectFit: 'contain',
                              width: 'fit-content',
                              filter: 'invert(1)',
                            }}
                          />
                        </ListItemAvatar>
                        <ListItemText
                          sx={{color: 'white'}}
                          primary={newObj.IconSettingWord[language]}
                        />
                      </ListItem>
                    </Link>
                  </List>
                </Box>
              </Grid>
            )} */}

            {/* {lintramaxAdminRole && (
              <Grid xs={12} sm={12} className='gridAdminItem' item>
                <Box className='boxAdmin'>
                  <Box
                    variant='body1'
                    sx={{
                      color: 'white',
                      backgroundColor: '#505559',
                      borderTopLeftRadius: '10px',
                      borderTopRightRadius: '10px',
                    }}
                    fontWeight='bold'
                    py={2}
                    pl={3}
                  >
                    {newObj.LintraMaxWord[language]}
                  </Box>
                  <Box className='boxAdminWrapper'>
                    <Box className='boxAdminImgCtr'>
                      <img src={macWP} className='boxAdminImg' alt='' />
                    </Box>
                    <List sx={{width: '100%', maxWidth: 300}}>
                      <Link
                        to='/uploadpalm'
                        sx={{
                          textDecoration: 'none',
                        }}
                      >
                        <ListItem divider>
                          <ListItemAvatar>
                            <Avatar
                              src={uploadMap}
                              style={{
                                background: 'transparent',
                                borderRadius: 0,
                                color: 'white',
                                objectFit: 'contain',
                                width: 'fit-content',
                                filter: 'invert(1)',
                              }}
                            />
                          </ListItemAvatar>
                          <ListItemText
                            sx={{color: 'white'}}
                            primary={newObj.UploadPalmOilDataWord[language]}
                          />
                        </ListItem>
                      </Link>
                      <Link
                        to='/uploadpaddy'
                        sx={{
                          textDecoration: 'none',
                        }}
                      >
                        <ListItem divider>
                          <ListItemAvatar>
                            <Avatar
                              src={uploadPaddy}
                              style={{
                                background: 'transparent',
                                borderRadius: 0,
                                color: 'white',
                                objectFit: 'contain',
                                width: 'fit-content',
                                filter: 'invert(1)',
                              }}
                            />
                          </ListItemAvatar>
                          <ListItemText
                            sx={{color: 'white'}}
                            primary={newObj.UploadPaddyDataWord[language]}
                          />
                        </ListItem>
                      </Link>
                      <Link
                        to='/uploadrubber'
                        sx={{
                          textDecoration: 'none',
                        }}
                      >
                        <ListItem divider>
                          <ListItemAvatar>
                            <Avatar
                              src={uploadRubber}
                              style={{
                                background: 'transparent',
                                borderRadius: 0,
                                color: 'white',
                                objectFit: 'contain',
                                width: 'fit-content',
                                filter: 'invert(1)',
                              }}
                            />
                          </ListItemAvatar>
                          <ListItemText
                            sx={{color: 'white'}}
                            primary={newObj.UploadRubberDataWord[language]}
                          />
                        </ListItem>
                      </Link>
                      <Link
                        to='/lintramaxarchivefiles'
                        sx={{
                          textDecoration: 'none',
                        }}
                      >
                        <ListItem divider>
                          <ListItemAvatar>
                            <Avatar
                              src={lintraMax}
                              style={{
                                background: 'transparent',
                                borderRadius: 0,
                                color: 'white',
                                objectFit: 'contain',
                                width: 'fit-content',
                                filter: 'invert(1)',
                              }}
                            />
                          </ListItemAvatar>
                          <ListItemText
                            sx={{color: 'white'}}
                            primary={newObj.LintraMaxArchiveFilesWord[language]}
                          />
                        </ListItem>
                      </Link>
                    </List>
                  </Box>
                </Box>
              </Grid>
            )} */}

            {userManagementRole && (
              <Grid xs={12} sm={12} className='gridAdminItem' item>
                <Box className='boxAdmin'>
                  <Box className='boxAdminHead'>
                    {newObj.UserAccessWord[language]}
                  </Box>
                  <Box className='boxAdminWrapper'>
                    <Box className='boxAdminImgCtr'>
                      <img
                        src={UserAccessAdmin}
                        className='boxAdminImg'
                        alt='user access admin'
                      />
                    </Box>
                    <Box className='boxAdminMenu'>
                      <Box className='boxAdminMenuItem'>
                        <Link to='/userList'>
                          <img
                            className='itemImg'
                            src={UserAccessIcon1}
                            alt='user access icon'
                          />
                          <Box className='itemText'>
                            <p>
                              <strong>{newObj.UserListWord[language]}</strong>
                            </p>
                            <p>{newObj.UsersDescription[language]}</p>
                          </Box>
                        </Link>
                        <Link to={'/userList?open=true'} className='itemBtn'>
                          Tambah Pengguna
                        </Link>
                      </Box>
                      <Box className='boxAdminMenuItem'>
                        <Link to='/usergroup'>
                          <img
                            className='itemImg'
                            src={UserAccessIcon2}
                            alt='user access icon 2'
                          />
                          <Box className='itemText'>
                            <p>
                              <strong>{newObj.UserGroupWord[language]}</strong>
                            </p>
                            <p>{newObj.UserGroupDescriptionWord[language]}</p>
                          </Box>
                        </Link>
                        <Link to={'/userGroup?open=true'} className='itemBtn'>
                          Tambah Kumpulan
                        </Link>
                      </Box>
                      <Box className='boxAdminMenuItem'>
                        <Link to='/pic'>
                          <img
                            className='itemImg'
                            src={UserAccessIcon3}
                            alt='user access icon 3'
                          />
                          <Box className='itemText'>
                            <p>
                              <strong>{newObj.UserPICWord[language]}</strong>
                            </p>
                            <p>
                              Akses kesemua butiran pengguna yang telah
                              terdaftar untuk pengurusan
                            </p>
                          </Box>
                        </Link>
                        {/* <Link to={'/pic?open=true'} className='itemBtn'>
                          Tambah PIC
                        </Link> */}
                      </Box>
                    </Box>
                    {/* <List sx={{width: '100%', maxWidth: 300}}>
                      <Link
                        to='/addnewuser'
                        sx={{
                          textDecoration: 'none',
                        }}
                      >
                        <ListItem divider>
                          <ListItemAvatar>
                            <Avatar
                              src={addNewUser}
                              style={{
                                background: 'transparent',
                                borderRadius: 0,
                                color: 'white',
                                objectFit: 'contain',
                                width: 'fit-content',
                                filter: 'invert(1)',
                              }}
                            />
                          </ListItemAvatar>
                          <ListItemText
                            sx={{color: 'white'}}
                            primary={newObj.AddNewUserWord[language]}
                          />
                        </ListItem>
                      </Link>
                      <Link
                        to='/userlist'
                        sx={{
                          textDecoration: 'none',
                        }}
                      >
                        <ListItem divider>
                          <ListItemAvatar>
                            <Avatar
                              src={addNewUser}
                              style={{
                                background: 'transparent',
                                borderRadius: 0,
                                color: 'white',
                                objectFit: 'contain',
                                width: 'fit-content',
                                filter: 'invert(1)',
                              }}
                            />
                          </ListItemAvatar>
                          <ListItemText
                            sx={{color: 'white'}}
                            primary={newObj.UserListWord[language]}
                          />
                        </ListItem>
                      </Link>
                      <Link
                        to='/addusergroup'
                        sx={{
                          textDecoration: 'none',
                        }}
                      >
                        <ListItem divider>
                          <ListItemAvatar>
                            <Avatar
                              src={users}
                              style={{
                                background: 'transparent',
                                borderRadius: 0,
                                color: 'white',
                                objectFit: 'contain',
                                width: 'fit-content',
                                filter: 'invert(1)',
                              }}
                            />
                          </ListItemAvatar>
                          <ListItemText
                            sx={{color: 'white'}}
                            primary={newObj.AddUserGroupWord[language]}
                          />
                        </ListItem>
                      </Link>
                      <Link
                        to='/usergroup'
                        sx={{
                          textDecoration: 'none',
                        }}
                      >
                        <ListItem divider>
                          <ListItemAvatar>
                            <Avatar
                              src={users}
                              style={{
                                background: 'transparent',
                                borderRadius: 0,
                                color: 'white',
                                objectFit: 'contain',
                                width: 'fit-content',
                                filter: 'invert(1)',
                              }}
                            />
                          </ListItemAvatar>
                          <ListItemText
                            sx={{color: 'white'}}
                            primary={newObj.UserGroupWord[language]}
                          />
                        </ListItem>
                      </Link>
                    </List> */}
                  </Box>
                </Box>
              </Grid>
            )}
            {applicationManagementRole && (
              <Grid xs={12} sm={12} className='gridAdminItem' item>
                <Box className='boxAdmin'>
                  <Box className='boxAdminHead'>
                    {newObj.SmartphoneAppWord[language]}
                  </Box>
                  <Box className='boxAdminWrapper'>
                    <Box className='boxAdminImgCtr'>
                      <img
                        src={MobileAppAdmin}
                        className='boxAdminImg'
                        alt='mobile app admin'
                      />
                    </Box>
                    <Box className='boxAdminMenu'>
                      <Box className='boxAdminMenuItem'>
                        <Link to='/program-kerja'>
                          <img
                            className='itemImg'
                            src={MobileAppIcon1}
                            alt='mobile app icon'
                          />
                          <Box className='itemText'>
                            <p>
                              <strong>
                                {newObj.ProgramKerjaWord[language]}
                              </strong>
                            </p>
                            <p>{newObj.ProgramKerjaDescription[language]}</p>
                          </Box>
                        </Link>
                      </Box>
                      {/* <Link to='/userGroup'>
                      <Box className='boxAdminMenuItem'>
                        <img className='itemImg' src={MobileAppIcon2} alt='' />
                        <Box className='itemText'>
                          <p>
                            <strong>
                              {newObj.ProjectStatusWord[language]}
                            </strong>
                          </p>
                          <p></p>
                        </Box>
                      </Box>
                    </Link> */}
                      <Box className='boxAdminMenuItem'>
                        <Link to='/application-authorization'>
                          <img
                            className='itemImg'
                            src={MobileAppIcon3}
                            alt='mobile app icon 3'
                          />
                          <Box className='itemText'>
                            <p>
                              <strong>
                                {newObj.PengesahanAplikasiWord[language]}
                              </strong>
                            </p>
                            <p>
                              {newObj.PengesahanAplikasiDescription[language]}
                            </p>
                          </Box>
                        </Link>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            )}
            {(atdAdminRole ||
              pengesyoranBajaAdminRole ||
              kewanganAdminRole ||
              pesertaLotAdminRole ||
              documentationAdminRole) && (
              <Grid xs={12} sm={12} className='gridAdminItem' item>
                <Box className='boxAdmin'>
                  <Box className='boxAdminHead'>
                    {newObj.UploadDataCenterWord[language]}
                  </Box>
                  <Box className='boxAdminWrapper'>
                    <Box className='boxAdminImgCtr'>
                      <img
                        src={OthersAdmin}
                        className='boxAdminImg'
                        alt='pthers admin'
                      />
                    </Box>
                    <Box className='boxAdminMenu'>
                      {atdAdminRole && (
                        <Box className='boxAdminMenuItem'>
                          <Link to='/atd'>
                            <img
                              className='itemImg'
                              src={OthersIcon1}
                              alt='icon'
                            />
                            <Box className='itemText'>
                              <p>
                                <strong>{newObj.ATDWord[language]}</strong>
                              </p>
                              <p>{newObj.ATDDescription[language]}</p>
                            </Box>
                          </Link>{' '}
                          <Link to={'/upload-atd'} className='itemBtn'>
                            Upload Data
                          </Link>
                        </Box>
                      )}
                      {pengesyoranBajaAdminRole && (
                        <Box className='boxAdminMenuItem'>
                          <Link to='/pengesyoran-baja'>
                            <img
                              className='itemImg'
                              src={OthersIcon2}
                              alt='icon'
                            />
                            <Box className='itemText'>
                              <p>
                                <strong>
                                  {newObj.FertilizerTrackingWord[language]}
                                </strong>
                              </p>
                              <p>
                                {newObj.FertilizerTrackingDescription[language]}
                              </p>
                            </Box>
                          </Link>{' '}
                          <Link
                            to={'/upload-pengesyoran-baja'}
                            className='itemBtn'
                          >
                            Upload Data
                          </Link>
                        </Box>
                      )}
                      {kewanganAdminRole && (
                        <Box className='boxAdminMenuItem'>
                          <Link to='/finance'>
                            <img
                              className='itemImg'
                              src={OthersIcon3}
                              alt='icon'
                            />
                            <Box className='itemText'>
                              <p>
                                <strong>{newObj.FinanceWord[language]}</strong>
                              </p>
                              <p>{newObj.FinanceDescription[language]}</p>
                            </Box>
                          </Link>{' '}
                          <Link to={'/upload-finance'} className='itemBtn'>
                            Upload Data
                          </Link>
                        </Box>
                      )}
                      {pesertaLotAdminRole && (
                        <Box className='boxAdminMenuItem'>
                          <Link to='/participants-and-lot'>
                            <img
                              className='itemImg'
                              src={OthersIcon3}
                              alt='icon'
                            />
                            <Box className='itemText'>
                              <p>
                                <strong>
                                  {newObj.ParticipantsAndLotWord[language]}
                                </strong>
                              </p>
                              <p>
                                {newObj.ParticipantsAndLotDescription[language]}
                              </p>
                            </Box>
                          </Link>
                          <Link
                            to={'/upload-participants-and-lot'}
                            className='itemBtn'
                          >
                            Upload Data
                          </Link>
                        </Box>
                      )}
                      {ppplsDataAdminRole && (
                        <Box className='boxAdminMenuItem'>
                          <Link to='/pppls'>
                            <img
                              className='itemImg'
                              src={OthersIcon3}
                              alt='icon'
                            />
                            <Box className='itemText'>
                              <p>
                                <strong>
                                  {newObj.PPPLSDataWord[language]}
                                </strong>
                              </p>
                              <p>{newObj.PPPLSDataDescription[language]}</p>
                            </Box>
                          </Link>
                          <Link to={'/upload-pppls'} className='itemBtn'>
                            Upload Data
                          </Link>
                        </Box>
                      )}
                      {documentationAdminRole && (
                        <Box className='boxAdminMenuItem'>
                          <Link to='/documentation'>
                            <img
                              className='itemImg'
                              src={OthersIcon4}
                              alt='icon'
                            />
                            <Box className='itemText'>
                              <p>
                                <strong>
                                  {newObj.DocumentationWord[language]}
                                </strong>
                              </p>
                              <p>{newObj.DocumentationDescription[language]}</p>
                            </Box>
                          </Link>
                        </Box>
                      )}
                    </Box>
                  </Box>
                </Box>
              </Grid>
            )}
          </Grid>
        </Container>
      </Container>
    </ThemeProvider>
  );
};

export default AdminPage;
